"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const lucide_vue_next_1 = require("lucide-vue-next");
const Probability_vue_1 = __importDefault(require("./Probability.vue"));
let RankingTopIndex = class RankingTopIndex extends vue_property_decorator_1.Vue {
    launchBoxplot(metric) {
        this.$emit('launchMetric', metric);
        // @ts-ignore
        window.mixpanel.track('BoxPlot Loaded', {
            origin: 'top',
        });
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], RankingTopIndex.prototype, "topMetric", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], RankingTopIndex.prototype, "dimension", void 0);
RankingTopIndex = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            ArrowUpRight: lucide_vue_next_1.ArrowUpRight,
            Probability: Probability_vue_1.default,
        },
    })
], RankingTopIndex);
exports.default = RankingTopIndex;
